import axiosInstance from '../variables/api/axiosInstance';

/** Signalisation des appels audio : entre en REST, ressort sur la file STOMP privée. */
const base = '/v1/appels';
const data = (r) => r.data?.data;

const appelService = {
  configIce: () => axiosInstance.get(`${base}/ice-config`, { skipErrorToast: true }).then(data),
  initier: (destinataireTrackingId, sdp, conversationTrackingId) =>
    axiosInstance.post(base, { destinataireTrackingId, sdp, conversationTrackingId }, { skipErrorToast: true }).then(data),
  repondre: (id, sdp) => axiosInstance.post(`${base}/${id}/reponse`, { sdp }, { skipErrorToast: true }).then(data),
  candidat: (id, candidat) => axiosInstance.post(`${base}/${id}/candidat`, { candidat }, { skipErrorToast: true }).then(data),
  terminer: (id, motif) => axiosInstance.post(`${base}/${id}/fin`, { motif }, { skipErrorToast: true }).then(data),
  historique: (taille = 30) => axiosInstance.get(`${base}/historique`, { params: { taille } }).then(data),
};

export default appelService;
